import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import * as Routes from '@/modules/routes';
import Axios from 'axios';
import Modal, { useModalManager, Footer } from '@/components/common/Modal';
import styles from './EditScore.module.scss';

interface EditMaxScoreProps {
  callback?: (num: number) => any;
  classroomId: number;
  initialMaxScore: number;
  lessonId?: number;
  programId: number;
  sectionId?: number;
  setMaxScore?: (next: number) => void;
}

const EditMaxScore = ({
  callback = () => {},
  classroomId,
  initialMaxScore,
  lessonId = null,
  programId,
  sectionId = null,
  setMaxScore: setMaxScoreCallback,
}: EditMaxScoreProps) => {
  const modalManager = useModalManager();
  const [maxScore, setMaxScore] = useState(initialMaxScore);

  return (
    <span className="tw-font-light">
      <div>
        <button
          className="dropdown-item tw-min-w-full tw-cursor-pointer focus:tw-bg-inherit"
          type="button"
          onClick={modalManager.open}
        >
          <i className="fa fa-edit" />
          Edit Max Score
        </button>

        <Modal
          closeModal={modalManager.close}
          headerText={`Set ${lessonId ? 'Lesson' : 'Section'} Notebook Score`}
          isOpen={modalManager.isOpen}
        >
          <Form
            initialValues={{ max_notebook_grade: maxScore }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <label className={styles.label} htmlFor="max-score">
                  Max Score:
                </label>

                <Field
                  className={styles.textInput}
                  component="input"
                  id="max-score"
                  min={0}
                  name="max_notebook_grade"
                  type="number"
                />

                <div className="mt30">
                  <p>Notes:</p>
                  <ul className="with-list-style mt5">
                    <li>All scores already assigned will remain the same value.</li>
                    <li>This change applies to all classes.</li>
                  </ul>
                </div>

                <Footer
                  secondaryButtonCallback={modalManager.close}
                />
              </form>
            )}
            onSubmit={(values) => {
              const resource = lessonId ? { lesson_id: lessonId } : { section_id: sectionId };

              const getPath = Routes.change_max_notebook_points_teacher_score_path(classroomId, {
                program_id: programId,
                ...resource,
              });

              Axios.post(getPath, values).then((response: { data: { max_notebook_points: string } }) => {
                setMaxScore(parseInt(response.data.max_notebook_points, 10));
                if (setMaxScoreCallback) setMaxScoreCallback(parseInt(response.data.max_notebook_points, 10));
                callback(parseInt(response.data.max_notebook_points, 10));
                $('#max-lesson-score').trigger('section_score_updated');
              });
            }}
          />
        </Modal>
      </div>
    </span>
  );
};

export default EditMaxScore;
